import { List }                                   from 'immutable';
import PropTypes                                  from 'prop-types';
import { connect }                                from 'react-redux';
import { createSelectResourceItemBySlug }         from '../../selectors/resourceSelectors';
import deprecated                                 from '../../utils/deprecated';
import { MapResourceItemApiUrlFromSlugPropTypes } from './mapResourceItemApiUrlFromSlug';
import {
  MAP_RESOURCE_DATA_PROP_RESOURCE_DATA,
  MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM,
  MAP_RESOURCE_PROP_RESOURCE_SLUG,
}                                                 from './mapResourceProps.const';


/**
 * HOC to map the 'resources' props from state, for collections of resources.
 *
 * This can be coupled with the following components to chain props up and down stream…
 *
 *    mapResourceName(
 *        mapResourceCollectionApiUrl(
 *            mapLoadResources()
 *        )
 *    )
 *
 * @param {string} resourceName Name of the resource.
 *
 * @return {function(*=): (ComponentClass<Omit<TInjectedProps, keyof {resourceItem: *, resourceData: *} & {}> &
 *   {resourceName: *, apiUrl: *}> & {WrappedComponent: Component<TInjectedProps>})}
 *
 * @deprecated mapResourceItemBySlug() should not be used, as it relies on the old method of storing API data.
 */
const mapResourceItemBySlug = ({resourceName}) => (Component) => {

  deprecated('mapResourceItemBySlug() should not be used, as it relies on the old method of storing API data.');

  const makeMapState = () => {

    const selectResourceItemBySlug = createSelectResourceItemBySlug(resourceName);

    return (state, {[MAP_RESOURCE_PROP_RESOURCE_SLUG]: resourceSlug}) => {

      const data = selectResourceItemBySlug(state, {resourceSlug});

      return {
        [MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM]: data,
        [MAP_RESOURCE_DATA_PROP_RESOURCE_DATA]: data,
      };

    };

  };

  const MapResourceItemBySlugUrl = connect(makeMapState, {})(Component);

  MapResourceItemBySlugUrl.propTypes = {

    ...MapResourceItemApiUrlFromSlugPropTypes,

  };

  MapResourceItemBySlugUrl.displayName = 'MapResourceItemBySlug';

  return MapResourceItemBySlugUrl;

};


export const MapResourceItemBySlugUrlPropTypes = {

  // Collection of resources.
  [MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM]: PropTypes.instanceOf(List),

  // Same as resourceCollection, but using a name that's common to collection & item data.
  [MAP_RESOURCE_DATA_PROP_RESOURCE_DATA]: PropTypes.instanceOf(List),

};


export default mapResourceItemBySlug;



// WEBPACK FOOTER //
// ./src/components/resources/mapResourceItemBySlug.js